/**
 * Created by Jerker Nord on 2024-06-03.
 */
import {BenjiKIVFastWinWaysContainer} from "../components/BenjiKIVFastWinWaysContainer";

export class BenjiKIVPoolFastWinWays {

    private _winWaysContainers:BenjiKIVFastWinWaysContainer[];

    public init():void {
        this._winWaysContainers = [];
        for(let i:number = 0; i < 6; i++) {
            this._winWaysContainers.push(this.createNewWinWaysContainer());
        }
    }

    private createNewWinWaysContainer():BenjiKIVFastWinWaysContainer {
        return new BenjiKIVFastWinWaysContainer();
    }

    public getWinWaysContainer(amount:number, ways:number):BenjiKIVFastWinWaysContainer {
        for(let i:number = 0; i < this._winWaysContainers.length; i++) {
            if(this._winWaysContainers[i].isUsed == false) {
                this._winWaysContainers[i].isUsed = true;
                this._winWaysContainers[i].setValues(amount, ways);
                return this._winWaysContainers[i];
            }
        }
        this._winWaysContainers.push(this.createNewWinWaysContainer());
        return this.getWinWaysContainer(amount, ways);
    }

    public resetAllUsed():void {
        for(let i:number = 0; i < this._winWaysContainers.length; i++) {
            this._winWaysContainers[i].reset();
        }
    }
}